// extracted by mini-css-extract-plugin
export var compactFilters = "_gx-4";
export var detailImage = "_gx-1";
export var dropdownContainer = "_gx-2";
export var imageContainer = "_gx-0";
export var selectedCard = "_gx-3";